import { FORTEM_URIS } from '@/constants/uris'
import { FundsFlowsPage } from '@/pages/funds/flows/page'
import { IcGuidelinesV2Page } from '@/pages/funds/ic-guidelines-v2/page'
import { ICGuidelinesPage } from '@/pages/funds/ic-guidelines/page'
import { ICReportPage } from '@/pages/funds/ic-report/page'
import { FundsLayout } from '@/pages/funds/layout'
import { ManagementReportPage } from '@/pages/funds/management-report/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const fundsRoutes = [
  {
    path: FORTEM_URIS.FUNDS.__INDEX__,
    element: <FundsLayout />,
    handle: {
      title: 'Funds',
    },
    children: [
      {
        path: FORTEM_URIS.FUNDS.FLOWS,
        element: <FundsFlowsPage />,
        handle: {
          title: 'PM Flows',
          docLink:
            'https://www.notion.so/Flow-based-Resize-367d1ec358578005bb97ea2cb6da8041?source=copy_link',
        },
      },
      {
        path: FORTEM_URIS.FUNDS.IC_GUIDELINES,
        element: <ICGuidelinesPage />,
        handle: {
          title: 'IC Guidelines',
        },
      },
      {
        path: FORTEM_URIS.FUNDS.IC_GUIDELINES_V2,
        element: <IcGuidelinesV2Page />,
        handle: {
          title: 'IC Guidelines *V2*',
          docLink:
            'https://www.notion.so/fortemcapital/IC-Guidelines-2-390d1ec35857802888f4f695de11701f?source=copy_link',
        },
      },
      {
        path: FORTEM_URIS.FUNDS.IC_REPORT,
        element: <ICReportPage />,
        handle: {
          title: 'IC Report',
        },
      },
      {
        path: FORTEM_URIS.FUNDS.MANAGEMENT_REPORT,
        element: <ManagementReportPage />,
        handle: {
          title: 'Management Report',
        },
      },
    ],
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
